import { create } from 'zustand';

interface SidebarState {
  collapsed: boolean;
  autoExpanded: boolean; // Track if sidebar was auto-expanded (should auto-collapse)
  toggle: () => void;
  setCollapsed: (collapsed: boolean) => void;
  setAutoExpanded: (autoExpanded: boolean) => void;
}

export const useSidebarStore = create<SidebarState>((set) => ({
  collapsed: localStorage.getItem('asi-sidebar-collapsed') === 'true',
  autoExpanded: false,
  toggle: () =>
    set((s) => {
      const next = !s.collapsed;
      localStorage.setItem('asi-sidebar-collapsed', String(next));
      return { collapsed: next, autoExpanded: false };
    }),
  setCollapsed: (collapsed) => {
    localStorage.setItem('asi-sidebar-collapsed', String(collapsed));
    set({ collapsed, autoExpanded: false });
  },
  setAutoExpanded: (autoExpanded) => set({ autoExpanded }),
}));
